const MESSAGES = [
  "ACQUISTO SICURO CON STRIPE",
  "FOCUS. METODO. COSTANZA.",
  "SCHEDE 100% PERSONALIZZATE SU MISURA",
  "ACCESSO IMMEDIATO VIA APP DEDICATA",
  "COACH LAUREATO IN SCIENZE MOTORIE",
];

const Strip = ({ hidden = false }) => (
  <div className="flex items-center gap-12 px-6" aria-hidden={hidden}>
    {MESSAGES.map((m, i) => (
      <span key={i} className="flex items-center gap-12">
        <span className="inline-flex items-center gap-2 whitespace-nowrap">
          {i === 0 && <span className="w-2 h-2 rounded-full bg-[#a020f0]"></span>}
          {m}
        </span>
        <span>•</span>
      </span>
    ))}
  </div>
);

export const PromoStrip = () => (
  <aside
    aria-label="Annunci promozionali"
    data-testid="promo-strip"
    className="bg-[#1b0d33] border-b border-[#a020f0]/30 py-2.5 overflow-hidden text-xs uppercase tracking-widest text-[#d8b4fe]"
  >
    <div className="mq-track font-semibold">
      <Strip />
      <Strip hidden />
    </div>
  </aside>
);
